import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
// Swiper CSS comes from application.bootstrap.scss (swiper-bundle.min); importing
// it here makes esbuild emit its own application.css, clobbering the sass bundle.

export default class extends Controller {
  connect() {
    const carousel = this.element.querySelector('.gallery-swiper')
    const pagination = this.element.querySelector('.swiper-pagination')
    const nextButton = this.element.querySelector('.swiper-button-next')
    const previousButton = this.element.querySelector('.swiper-button-prev')

    this.swiper = new Swiper(carousel, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 2,
      spaceBetween: 24,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true
      },
      navigation: {
        nextEl: nextButton,
        prevEl: previousButton,
      },
      breakpoints: {
        // Mobile
        320: {
          slidesPerView: 2,
          spaceBetween: 12
        },
        // Tablet
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // Desktop
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        // Large Desktop
        1280: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  showDetails(event) {
    event.preventDefault()
  }
}
